/* SORIVO — global UX (all templates). Header reacts to scrolling. Progressive enhancement only. */
(function () {
  'use strict';
  var header = document.querySelector('.sorivo-premium-header');
  if (!header) return;
  var html = document.documentElement;
  var menu = header.querySelector('details');
  var last = 0, ticking = false;
  /* Horizon scrolls inside .page-wrapper on desktop; the window scrolls on phones. */
  function findScroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw) {
      var o = window.getComputedStyle(pw).overflowY;
      if (o === 'auto' || o === 'scroll') return pw;
    }
    return null;
  }
  var sc = findScroller();
  function y() { return sc ? sc.scrollTop : (window.pageYOffset || html.scrollTop || 0); }
  function update() {
    ticking = false;
    var cur = y();
    var open = !!(menu && menu.open);
    header.classList.toggle('is-scrolled', cur > 24);
    if (open || cur < 240 || cur < last - 3) header.classList.remove('is-hidden');
    else if (cur > last + 6) header.classList.add('is-hidden');
    last = cur;
  }
  function request() {
    if (ticking) return;
    ticking = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(update); else setTimeout(update, 16);
  }
  document.addEventListener('scroll', request, { passive: true, capture: true });
  window.addEventListener('resize', function () { sc = findScroller(); request(); }, { passive: true });
  header.addEventListener('focusin', function () { header.classList.remove('is-hidden'); });
  if (menu) {
    menu.addEventListener('toggle', function () {
      header.classList.remove('is-hidden');
      html.classList.toggle('sx-menu-open', menu.open);
    });
  }
  update();
})();